<ng-container *ngIf="isAdmin">
    <ng-container *ngIf="readyEvents">
        <ng-container>

            <app-table [columns]="headerTableEvents" [dataSource]="eventsList" [hasButton]="false"
            [hasHeaderActions]="false"></app-table>
   
        </ng-container>
    </ng-container>
    <ng-container *ngIf="!readyEvents">
        <div class="cf-dlg-loading"><div class="cf-dlg-loading__dots"><span></span><span></span><span></span></div></div>
    </ng-container>
</ng-container>